<template lang="html">
<div class="pgInner">

    <div class="headBar">新建申报</div>

    <div class="pgbody" :style="'height:' + pageH + 'px;'">
         <el-scrollbar ref="scroller" style="height:100%;">

           <div class="tabNavs" ref="tabNavs">
                <div v-for="(item,index) in navs" :key="index" @click="tabChange($event,index)" :class="['tabItem',{'act':navAct===index}]">
                     {{item}}
                </div>
                <div class="moveLine" :style="lineStr"></div>
           </div>

           <div class="tabContent">
                <Subpage1 ref="subpage1" @inited="readyHandle" v-show="navAct===0" />
                <Subpage2 ref="subpage2" @inited="readyHandle" v-show="navAct===1" />
                <Subpage3 ref="subpage3" @inited="readyHandle" v-show="navAct===2" />
                <Subpage4 ref="subpage4" @inited="readyHandle" v-show="navAct===3" />
                <Subpage5 ref="subpage5" @inited="readyHandle" v-show="navAct===4" />
           </div>

         </el-scrollbar>
    </div>

    <div class="pagefoot">
        <div v-if="pgState" class="loading">
             <span v-if="pgState == 1">初始化中...</span>
             <span v-if="pgState == 2">数据保存中...</span>
             <i class="el-icon-loading"></i>
        </div>
        <div v-else>
             <el-button @click="directSave(1)" type="primary" size="small">立即发布</el-button>
             <el-button @click="ansSave" type="primary" size="small">发布并新建解读</el-button>
             <el-button @click="directSave(3)" plain size="small">存为草稿</el-button>
             <el-button @click="goReturn" plain size="small">取消</el-button>
        </div>

    </div>

    <unsModel @goCreate="goCreate" ref="unsPop" />

</div>
</template>

<script>
import Subpage1 from "./src/Subpage1";
import Subpage2 from "./src/Subpage2";
import Subpage3 from "./src/Subpage3";
import Subpage4 from "./src/Subpage4";
import Subpage5 from "./src/Subpage5";
import unsModel from "./src/unsModel";

import { decEdit,decPredat,decTextSave,decRules } from "@/api/declare/declare";

export default {
    components:{
        Subpage1,
        Subpage2,
        Subpage3,
        Subpage4,
        Subpage5,
        unsModel
    },
    computed:{
        lineStr:function(){
            var str = '';
            if(this.navAct === 0 || this.navAct == 4){
               str = 'width:60px;';
            }else {
               str =  'width:30px;';
            }

            str = str + "left:" + this.navX + "px;";

            return str;
        },
        pgState:function(){
            var state = 0;
            if(this.id && this.readyKey !== 5){
                state = 1;
            }

            if(this.uploadIng){
                state = 2;
            }

            return state;
        }
    },
    data(){
        return{

            id:'',
            navs:['基本信息','原文','细则','指南','规则匹配'],
            navAct:0,
            navX:15,
            pageH:'',
            readyKey:0,
            uploadIng:false,

            postPms1:{
               id:'',
               type:1
            },

            postPms2:{
               cqjSbzcDeclarationPolicyId:''
            }

        }
    },

    methods:{
        tabChange:function(e,inx){

            var tabNavs = this.$refs.tabNavs;
            this.navAct = inx;
            this.navX = e.target.offsetLeft;

        },
        readyHandle:function(){
            this.readyKey++;
        },
        pageFix:function(){
            this.pageH = document.documentElement.clientHeight - 205;
        },

        ansSave:function(type){
            this.$refs.unsPop.openstate = true;
        },

        goCreate:function(e){
           this.directSave(1,e)
        },

        directSave:function(status,unsType){
            var vues = this;
            var wait1 = this.$refs.subpage1.saveReturn();
            var wait2 = this.$refs.subpage5.saveReturn();

            var waitArr = [];

            waitArr.push(wait1);
            waitArr.push(wait2);

            Promise.all(waitArr).then(res => {
                goSave(res);
            })

            async function goSave(res){
                var pms1 = res[0];
                var pms2 = vues.$refs.subpage2.saveReturn();
                var pms3 = vues.$refs.subpage3.saveReturn();
                var pms4 = vues.$refs.subpage4.saveReturn();
                var pms5 = res[1];

                var dPare = (new Date(pms1.applicationDeadline)).getTime() - (new Date(pms1.applicationStartDate)).getTime();

                if(!pms1){
                    vues.$message.error('基本信息未填写完成！');
                }else if(!pms2){
                    vues.$message.error('申报原文不能为空！');
                }else if(dPare <= 0){
                    vues.$message.error('申报截止日期不能小于开始日期！');
                }else{
                    var promiseArr = [];

                    vues.uploadIng = true;

                    // promiseArr.push(new Promise((resolve,reject) => {
                    //     var pms = $.extend({},vues.postPms1,pms1);
                    //     pms.status = status;
                    //     decEdit({declarationPolicy:pms}).then(res => {
                    //         resolve(res);
                    //     }).catch(err => {
                    //         reject(err);
                    //     })
                    // }))
                    //
                    // promiseArr.push(new Promise((resolve,reject) => {
                    //     var pms = $.extend({},vues.postPms2,pms2);
                    //     pms.status = status;
                    //     decTextSave({policyReleaseContent:pms}).then(res => {
                    //         resolve(res);
                    //     }).catch(err => {
                    //         reject(err);
                    //     })
                    // }))
                    //
                    // if(pms3){
                    //     promiseArr.push(new Promise((resolve,reject) => {
                    //         var pms = $.extend({},vues.postPms2,pms3);
                    //         pms.status = status;
                    //         decTextSave({policyReleaseContent:pms}).then(res => {
                    //             resolve(res);
                    //         }).catch(err => {
                    //             reject(err);
                    //         })
                    //     }))
                    // }
                    //
                    // if(pms4){
                    //     promiseArr.push(new Promise((resolve,reject) => {
                    //         var pms = $.extend({},vues.postPms3,pms4);
                    //         pms.status = status;
                    //         decTextSave({policyReleaseContent:pms}).then(res => {
                    //             resolve(res);
                    //         }).catch(err => {
                    //             reject(err);
                    //         })
                    //     }))
                    // }
                    //
                    // if(pms5){
                    //     promiseArr.push(new Promise((resolve,reject) => {
                    //         var pms = $.extend({},vues.postPms2,pms5);
                    //         pms.status = status;
                    //         decRules({matchRule:pms}).then(res => {
                    //             resolve(res);
                    //         }).catch(err => {
                    //             reject(err);
                    //         })
                    //     }))
                    // }
                    //
                    // Promise.all(promiseArr).then(res => {
                    //     vues.uploadIng = false;
                    //     if(unsType){
                    //         vues.$router.push({
                    //             path:'uns_edit',
                    //             query:{
                    //                 pid:vues.postPms1.id,
                    //                 type:unsType
                    //             }
                    //         })
                    //     }else{
                    //         vues.$router.push('declare');
                    //     }
                    // }).catch(err => {
                    //     vues.uploadIng = false;
                    // });

                    {
                       let  pms = $.extend({},vues.postPms1,pms1);
                       pms.status = status;
                       await decEdit({declarationPolicy:pms});
                    }

                    {
                        let pms = $.extend({},vues.postPms2,pms2);
                        pms.status = status;
                        await decTextSave({policyReleaseContent:pms});
                    }

                    if(pms3){
                        let pms = $.extend({},vues.postPms2,pms3);
                        pms.status = status;
                        await decTextSave({policyReleaseContent:pms});
                    }

                    if(pms4){
                        let pms = $.extend({},vues.postPms2,pms4);
                        pms.status = status;
                        decTextSave({policyReleaseContent:pms});
                    }

                    if(pms5){
                        let pms = $.extend({},vues.postPms2,pms5);
                        let newPms = {};
                        for(let key in pms){
                            if(pms5[key] === 0){
                               newPms[key] = '';
                            }else{
                               newPms[key] = pms[key];
                            }
                        }
                        pms.status = status;
                        decRules({matchRule:newPms});
                    }

                    vues.uploadIng = false;
                    if(unsType){
                        vues.$router.push({
                            path:'uns_edit',
                            query:{
                                pid:vues.postPms1.id,
                                type:unsType
                            }
                        })
                    }else{
                        vues.$router.push('declare');
                    }
                }
            }


        },

        goReturn:function(){
            this.$router.go(-1);
        },

        prevSet:function(){

            var vues = this;
            var querys = this.$route.query;

            // 底部定位
            this.pageFix();

            // 获取初始 ID
            if(querys.id){
                vues.postPms1.id = querys.id;
                vues.postPms2.cqjSbzcDeclarationPolicyId = querys.id;
            }else{
                decEdit({declarationPolicy:this.postPms1}).then(res => {
                    vues.postPms1.id = res.declarationPolicy.id;
                    vues.postPms2.cqjSbzcDeclarationPolicyId = res.declarationPolicy.id;
                }).catch(err => {});
            }

        }
    },
    created:function(){
        var vues = this;
        var querys = this.$route.query;

        this.prevSet();
        $(window).resize(function(){
            vues.pageFix();
            if(vues.$refs.scroller&&vues.$refs.scroller.$data){
                vues.$refs.scroller.$data.sizeHeight = this.pageH;
            }
    	})

        if(querys.id){
             this.id = querys.id;
        }

    }


}
</script>

<style lang="scss" scoped>

.pgInner{
  background: #f5f5f5;
}

.headBar{
  height: 55px;
  line-height: 55px;
  font-size: 16px;
  padding-left: 20px;
  background: white;
}

.pgbody{
  margin: 20px;
}

.tabNavs{
  height: 50px;
  padding-left: 15px;
  background: white;
  position: relative;
  .tabItem{
     float: left;
     height: 50px;
     line-height: 50px;
     font-size: 15px;
     margin-right: 45px;
     cursor: pointer;
  }
  .tabItem.act{
    color: rgb(86, 119, 252);
  }
  .moveLine{
    height: 2px;
    background: rgb(86, 119, 252);
    position: absolute;
    bottom: 0px;

    transition-property: all;
    transition-duration: 0.2s;
  }
}

.tabContent{
  padding: 20px;
  background: white;
}

.pagefoot{
  height: 60px;
  line-height: 60px;
  background: white;
  padding-left: 20px;
  position: relative;
  z-index: 2;

  .loading{
     font-size: 14px;
     padding-left: 24px;
     color: #AEAEAE;
     i{
         font-size: 18px;
         vertical-align: middle;
     }
  }
}

</style>



// WEBPACK FOOTER //
// declareEdit.vue?14bebbd2